import EllipsisTextTooltip from './ellipsis-text-tooltip';

export default EllipsisTextTooltip;